import { FontSize } from './font-size';

export const ICON_SIZE_CLASS_MAP: { [key in FontSize]: string } = {
  [FontSize.XLarge]: 'svg-icon--300',
  [FontSize.Large]: 'svg-icon--250',
  [FontSize.Medium]: 'svg-icon--200',
  [FontSize.Small]: 'svg-icon--150',
  [FontSize.XSmall]: 'svg-icon--100',
};
